import {
  FETCH_ROUTE_LIST,
  FETCH_ROUTE_DETAIL,
  FETCH_ROUTE_CATEGORY,
  FETCH_ROUTE_FILTER,
  FETCH_RECOMMEND_ROUTE_LIST,
  TOGGLE_ROUTE_FAVOUR,
  FETCH_TOUR_DETAIL,
} from '../mutation-types'

const initialState = {
  recommendRoutes: [],
  routes: [],
  categories: [],
  cities: [],
  dateLabels: [],
  detail: {
    introductions: [],
    travelDetails: [],
    prices: [],
    city: {},
  },
  tourDetail: {
    introductions: [],
  },
}

const mutations = {
  [FETCH_ROUTE_LIST](state, data) {
    state.routes = data.routes
  },

  [FETCH_ROUTE_DETAIL](state, data) {
    state.detail = data
  },

  [FETCH_ROUTE_CATEGORY](state, data) {
    state.categories = data.categories
  },

  [FETCH_ROUTE_FILTER](state, data) {
    state.cities = data.cities
    state.dateLabels = data.dateLabels
  },

  [FETCH_RECOMMEND_ROUTE_LIST](state, data) {
    state.recommendRoutes = data.routes
  },

  [TOGGLE_ROUTE_FAVOUR](state, add) {
    state.detail.isFavorite = add
  },

  [FETCH_TOUR_DETAIL](state, data) {
    state.tourDetail = data
  },
}

export default {
  state: initialState,
  mutations,
}



// WEBPACK FOOTER //
// ./client/vuex/modules/route.js